export const getResiduos = (state) => state.residuos.lista
export const getTotalResiduos = (state) => state.residuos.total
export const getIsCarregandoListaResiduos = (state) => state.residuos.isCarregandoLista
export const getResiduosSelecionado = (state) => state.residuos.selecionado
export const getIsCarregandoResiduos = (state) => state.residuos.isCarregandoResiduos
export const getIsSavingResiduos = (state) => state.residuos.isSaving
